module.exports = {
    "dismiss": `Hylk\xe4\xe4`
};


//# sourceMappingURL=fi-FI.main.js.map
